<template>
  <Row>
    <Col span="24">
      <!-- <div
        style="
          display: flex;
          width: 100%;
          background: linear-gradient(to bottom, #ffffff, #dddddd);
          margin-bottom: 20px;
        "
      >
        <img
          style="background: #02a0e7"
          src="../../../static/img/Buy/icon-home.png"
          alt="暂无照片"
        />
        <Breadcrumb style="margin: 10px 0 0 30px" separator=">">
          <BreadcrumbItem to="/">首页</BreadcrumbItem>
          <BreadcrumbItem to="/home/News">新闻资讯</BreadcrumbItem>
          <BreadcrumbItem>行业新闻</BreadcrumbItem>
        </Breadcrumb>
      </div> -->
      <div class="res_div">
        <p class="res_div_p">{{ title }}</p>
        <div class="res_div_div"></div>
        <div style="text-align: center">
          <span class="news_ul_div_div02_sp">
            发布时间：2020-12-01
          </span>
        </div>
        <div v-for="(item, index) in img" :key="index">
          <p class="font_div">{{ item.p }}</p>
          <img v-if="item.imgUrl !== ''" :src="item.imgUrl" alt="暂无照片" />
        </div>
      </div>
    </Col>
  </Row>
</template>

<script>
export default {
  data() {
    return {
      title:
        "2020年中建科技月中建五局第三届技术论坛-南秀科技虚拟质量样板荣获二等奖",
      img: [
        {
          imgUrl: "../../../static/img/News/NewsTwo/NewsTwo01.jpg",
          p:
            "11月23日-24日，2020年中建科技月中建五局分会场暨中建五局第三届技术论坛在重庆成功举办。中国工程院院士、著名岩土工程专家郑颖人，中国工程院院士、著名结构工程专家周绪红，重庆市科学技术局党委委员、副局长陈军，天津大学研究生院常务副院长、教授郑刚出席并作专题讲座，重庆市科学技术局、中建集团、中建五局相关负责人、专家、设计、施工建设相关管理人员和技术人员等共计150余人参会。\n" +
            "会中，中建五局领导肯定了虚拟质量样板在建设建筑行业信息化方面取得的成就和作用，现场颁布局级2019年度科学技术奖共15项，其中中建五局河南公司联合南秀科技研发的“虚拟质量样板”获得二等奖。",
        },
        {
          imgUrl: "../../../static/img/News/NewsTwo/NewsTwo02.jpg",
          p: "",
        },
        {
          imgUrl: "../../../static/img/News/NewsTwo/NewsTwo03.jpg",
          p:
            "会议上副总经理、总工程师李凯做出指示:\n" +
            "      科技工作方面要求加强对科技工作重要性的认识、强化科技创新意识、提升总结集成能力。要求对本次会议精神传达学习、做好宣传报道并加强组织领导推动落实。随着科技发展驶入快车道，以虚拟质量样板为代表的新一代信息技术与建筑领域加速融合，将推动建筑数字化建设走向新台阶。\n" +
            "虚拟质量样板获得了中建五局多位领导的高度认可，加深了对南秀科技以及目前建设行业信息化所处的阶段和未来的发展前景的了解和思考。同时，我们也欢迎更多的企业来考察交流，将继续以建筑产业升级的历史机遇为契机，服务于建筑产业的全周期，将BIM技术、智慧工地为代表应用成果转化为企业效益，与施工企业一起，为建筑行业发展搭建良好的信息化平台！",
        },
      ],
    };
  },
  mounted() {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  },
  methods: {
    getUnderStandMore() {
      this.$router.push({
        name: "AR",
      });
    },
  },
};
</script>

<style scoped>
.res_div img {
  width: 96%;
  margin: 10px 0;
}

.res_div_p {
  font-size: 30px;
  font-weight: bold;
  color: #000;
}

.font_div {
  font-size: 16px;
  line-height: 26px;
  margin-bottom: 10px;
}

.res_div_div {
  border-bottom: 1px dashed #e1e1e1;
  margin: 10px 0;
}

.news_ul_div_div02_sp {
  font-size: 12px;
  color: #888;
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/News/NewsTwo.vue